import { Tooltip } from '@meitu/saas-ui';
import { type TextLayer } from '@meitu/saas-editor-core/es/layers/text-layer';
import { TextAlignType, type ITextLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import './style.less';
import Dropdown from '@/components/edgeless-components/dropdown/drapdown';
import IconTextItem from '@/components/edgeless-components/icon-text-item/icon-text-item';

type Props = {
    layerId: string;
};

const FALLBACK_TEXT_ALIGN = TextAlignType.CENTER;

const TEXT_ALIGN_ICONS: Record<TextAlignType, string> = {
    [TextAlignType.LEFT]: 'TextAlignmentBothOfEndBold',
    [TextAlignType.CENTER]: 'TextAlignmentCenterBold',
    [TextAlignType.RIGHT]: 'TextAlignmentRightBold',
    [TextAlignType.JUSTIFY]: 'TextAlignmentJustifiedBold',
};

export const EdgelessTextAlign = ({ layerId }: Props) => {
    const { $t } = useLocaleStore();

    const editor = useEditor();

    const props = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as ITextLayerProps;
        const { textAlign } = layerData;

        return {
            textAlign,
        };
    });

    const textAlign = props?.textAlign || FALLBACK_TEXT_ALIGN;
    const iconName = TEXT_ALIGN_ICONS[textAlign];

    const handleSetAlign = (align: TextAlignType) => {
        editor.getInstance<TextLayer>('TextLayer').setTextAlign(layerId, align);
    };

    return (
        <Dropdown icon={iconName} style={{ width: 168 }}>
            <div className="edgeless-text-align__group">
                <Tooltip placement="top" title={$t((v) => v.textAlignMent.alignLeft)}>
                    <IconTextItem
                        active={textAlign === TextAlignType.LEFT}
                        icon={TEXT_ALIGN_ICONS[TextAlignType.LEFT]}
                        onClick={() => handleSetAlign(TextAlignType.LEFT)}
                    />
                </Tooltip>
                <Tooltip placement="top" title={$t((v) => v.Text_BaseToolbar_AlignCenter)}>
                    <IconTextItem
                        active={textAlign === TextAlignType.CENTER}
                        icon={TEXT_ALIGN_ICONS[TextAlignType.CENTER]}
                        onClick={() => handleSetAlign(TextAlignType.CENTER)}
                    />
                </Tooltip>
                <Tooltip placement="top" title={$t((v) => v.textAlignMent.alignRight)}>
                    <IconTextItem
                        active={textAlign === TextAlignType.RIGHT}
                        icon={TEXT_ALIGN_ICONS[TextAlignType.RIGHT]}
                        onClick={() => handleSetAlign(TextAlignType.RIGHT)}
                    />
                </Tooltip>
                <Tooltip placement="top" title={$t((v) => v.textAlignMent.alignBetween)}>
                    <IconTextItem
                        active={textAlign === TextAlignType.JUSTIFY}
                        icon={TEXT_ALIGN_ICONS[TextAlignType.JUSTIFY]}
                        onClick={() => handleSetAlign(TextAlignType.JUSTIFY)}
                    />
                </Tooltip>
            </div>
        </Dropdown>
    );
};
